export const TOOLTIP_TEXT_REACH_LIMIT = "activation.topics.link.existing.kw";